import React from "react";
import { Create as RaCreate } from "react-admin";
import { useHistory } from "react-router-dom";
import { useFormStyles } from "../components/forms/useStyles";
import Form from "./Form";

const Create = (props) => {
	const classes = useFormStyles();
	const history = useHistory();
	const handleSuccess = (p) => {
		history.go(-1);
	};
	return (
		<RaCreate {...props} classes={classes} onSuccess={handleSuccess}>
			<Form />
		</RaCreate>
	);
};
export default Create;
